var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMylogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 24 24",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5C20.999 16.8686 20.7953 17.2068 20.47 17.38L12.57 21.82C12.2272 22.0578 11.7728 22.0578 11.43 21.82L3.53 17.38C3.20465 17.2068 3.00098 16.8686 3 16.5L3 7.5C3.00098 7.13141 3.20465 6.79324 3.53 6.62L11.43 2.18C11.7728 1.94219 12.2272 1.94219 12.57 2.18L20.47 6.62C20.7953 6.79324 20.999 7.13141 21 7.5L21 16.5M12 4.15L5 8.09L5 15.91L12 19.85L19 15.91L19 8.09L12 4.15M12 6.23L16.9 9.06L12 11.89L7.1 9.06L12 6.23M17 14.89L13 17.2L13 13.62L17 11.31L17 14.89M11 17.2L7 14.89L7 11.31L11 13.62L11 17.2Z",
    fill: "#9bfb97",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylogo);
export default __webpack_public_path__ + "static/media/mylogo.c6d894cd8db2d0413aef2a6d514e1a73.svg";
export { ForwardRef as ReactComponent };